var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_511_25830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0929 48.9071C31.1361 41.9502 19.8177 41.9502 12.8608 48.9071L5.21764 56.5503C-1.73921 63.5071 -1.73921 74.8255 5.21764 81.7824C12.1745 88.7392 23.4929 88.7392 30.4497 81.7824L38.0929 74.1392C45.0498 67.1823 45.0498 55.8639 38.0929 48.9071ZM23.2407 74.5733C20.2484 77.5648 15.4183 77.5655 12.4267 74.5733C9.43449 71.5817 9.43515 66.7509 12.4267 63.7593L20.0699 56.1162C23.0621 53.1246 27.8916 53.1246 30.8838 56.1162C33.876 59.1077 33.8754 63.9379 30.8838 66.9301L23.2407 74.5733Z",
    fill: "#6A7078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.094 74.1383L30.4508 81.7815C23.494 88.7384 12.1756 88.7384 5.21875 81.7815L12.4278 74.5724C15.4194 77.5647 20.2495 77.564 23.2418 74.5724L30.8849 66.9293C33.8765 63.937 33.8765 59.1075 30.8849 56.1153L38.094 48.9062C45.0509 55.8631 45.0509 67.1815 38.094 74.1383V74.1383Z",
    fill: "#4C5157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7804 5.21764C74.8236 -1.73921 63.5052 -1.73921 56.5483 5.21764L48.9051 12.8608C41.9483 19.8177 41.9483 31.1361 48.9051 38.0929C55.862 45.0498 67.1804 45.0498 74.1372 38.0929L81.7804 30.4497C88.7373 23.4929 88.7373 12.1745 81.7804 5.21764V5.21764ZM66.9282 30.8838C63.9366 33.8754 59.1064 33.8754 56.1142 30.8838C53.122 27.8923 53.1227 23.0614 56.1142 20.0699L63.7574 12.4267C66.7496 9.43449 71.5791 9.43449 74.5713 12.4267C77.5635 15.4183 77.5635 20.2484 74.5713 23.2407L66.9282 30.8838Z",
    fill: "#6A7078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5395 51.8972L67.9272 56.734L57.1133 53.1291L58.7255 48.293L69.5395 51.8972Z",
    fill: "rgb(6,156,240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1259 57.1113L56.7301 67.9253L51.8933 69.5375L48.2891 58.7236L53.1259 57.1113Z",
    fill: "rgb(6,156,240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1024 17.4609L38.7066 28.2749L33.8698 29.8872L30.2656 19.0732L35.1024 17.4609Z",
    fill: "rgb(6,156,240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8865 33.8737L28.2749 38.7105L17.4609 35.1063L19.0725 30.2695L29.8865 33.8737Z",
    fill: "rgb(6,156,240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7815 30.4508L74.1383 38.094C67.1815 45.0509 55.8631 45.0509 48.9062 38.094L56.1153 30.8849C59.1069 33.8765 63.9377 33.8765 66.9293 30.8849L74.5724 23.2418C77.5647 20.2495 77.5647 15.4194 74.5724 12.4278L81.7815 5.21875C88.7384 12.1756 88.7384 23.494 81.7815 30.4508V30.4508Z",
    fill: "#4C5157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3245 23.6758C60.333 20.6836 55.5028 20.6836 52.5106 23.6758L39.8945 36.2919L50.7085 47.1051L63.3245 34.4891C66.3167 31.4975 66.3167 26.6674 63.3245 23.6758Z",
    fill: "rgb(6,156,240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3238 34.4891L50.7078 47.1051L45.3008 41.6988L63.3238 23.6758C66.316 26.6673 66.316 31.4975 63.3238 34.4891Z",
    fill: "rgb(0,121,216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2894 39.8945L23.6734 52.5106C20.6818 55.5028 20.6818 60.333 23.6734 63.3245C26.6649 66.3167 31.4957 66.3161 34.4873 63.3245L47.1033 50.7085L36.2894 39.8945Z",
    fill: "rgb(6,156,240)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6988 45.3027L47.1051 50.7097L34.4891 63.3258C31.4975 66.3173 26.6673 66.318 23.6758 63.3258L41.6988 45.3027Z",
    fill: "rgb(0,121,216)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_511_25830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLinkIcon);
export default __webpack_public_path__ + "static/media/broken-link_icon.9e3e828ad700dc76464bc6621aa3250e.svg";
export { ForwardRef as ReactComponent };